import React, { useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import { useAuthDataContext } from "../AuthDataProvider";

import { useNavigate } from "react-router-dom";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

function LogoutButton() {
  const navigate = useNavigate();

  const [loggedOut, setLoggedOut] = React.useState(false);
  const { onLogout } = useAuthDataContext();

  const logout = () => {
    onLogout();
    setLoggedOut(true);
  };

  useEffect(() => {
    if (loggedOut) {
      navigate("/login");
    }
  }, [loggedOut, navigate]);

  return (
    <IconButton color="inherit" onClick={logout}>
      <ExitToAppIcon />
    </IconButton>
  );
}

export default LogoutButton;
